import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withKeys as _withKeys, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "tabs" }
const _hoisted_2 = ["aria-pressed", "tabindex", "onClick", "onKeydown"]

type Props = {
  tabOptions: any[]
}
type Emits = {
  (e: 'changeTab', value): void
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ButtonGroupNoIcons',
  props: {
    tabOptions: {}
  },
  emits: ["changeTab"],
  setup(__props: any, { emit: __emit }) {


const emits = __emit
function selectTab(option, event?: Event, preventDefault?: boolean) {
  if (event && preventDefault) event.preventDefault() // Prevent space bar scrolling
  if (option.active || option.disabled) return
  emits('changeTab', option.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabOptions, (option) => {
      return (_openBlock(), _createElementBlock("div", {
        key: option.title,
        "aria-pressed": option.active,
        class: _normalizeClass(["tabs__item", { tabs__item__active: option.active, tabs__item__disabled: option.disabled }]),
        role: "button",
        tabindex: option.disabled ? -1 : 0,
        onClick: ($event: any) => (selectTab(option)),
        onKeydown: [
          _withKeys(($event: any) => (selectTab(option)), ["enter"]),
          _withKeys((event) => selectTab(option, event, true), ["space"])
        ]
      }, _toDisplayString(option.title), 43, _hoisted_2))
    }), 128))
  ]))
}
}

})